import { Button, Layout, Menu } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MenuFoldOutlined, MenuUnfoldOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import './index.scss';
import { SidebarProps } from './types';
import GetSupportModal from '../GetSupport';
import ChatNav from './ChatNav';

const SIDEBAR_WIDTH = 260;
const SIDEBAR_COLLAPSED_WIDTH = 80;

// Global sidebar
const Sidebar: FC<SidebarProps> = (props) => {
	// Inits
	const { Sider } = Layout;
	const {
		handleSidebar,
		items,
		isGetSupportButton,
		selectedSidebar,
		collapsed = false,
		onCollapse,
		showChatNav = false,
	} = props;

	const [supportModalOpen, setSupportModalOpen] = useState(false);
	// const [isLoading,setIsLoading] = useState(false)

	// Which page-menu submenus are open. Controlled (rather than defaultOpenKeys)
	// so opening the chat can collapse them: the /chat page needs the vertical
	// room for the thread list, so entering it closes any expanded submenu —
	// Payroll Allocations especially. The user can still re-expand it while there.
	const { pathname } = useLocation();
	const [openKeys, setOpenKeys] = useState<string[]>([]);
	useEffect(() => {
		if (pathname === '/chat') {
			setOpenKeys([]);
		}
	}, [pathname]);

	const handleSubmit = (value: string) => {
		console.log('Values: ', value);
		setSupportModalOpen(false);
	};

	const handleCancel = () => {
		setSupportModalOpen(false);
	};

	const trigger = onCollapse ? (
		<button
			type="button"
			onClick={() => onCollapse(!collapsed)}
			className={styles.sidebar__trigger}
			aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
		>
			{collapsed ? (
				<MenuUnfoldOutlined style={{ fontSize: 16, color: '#fff' }} />
			) : (
				<MenuFoldOutlined style={{ fontSize: 16, color: '#fff' }} />
			)}
		</button>
	) : null;

	// JSX
	return (
		<Sider
			width={SIDEBAR_WIDTH}
			collapsedWidth={SIDEBAR_COLLAPSED_WIDTH}
			collapsed={collapsed}
			collapsible={!!onCollapse}
			trigger={trigger}
			style={{
				background: items?.length === 0 ? '#f8f1e9' : '#344735',
				maxHeight: '100%',
				height: '100%',
				// Clip at the Sider: the page menu and the chat thread list each
				// scroll on their own (see index.module.scss); Get Support stays fixed.
				overflow: 'hidden',
			}}
			className={`${styles.sidebar} ${collapsed ? 'sidebar-collapsed' : ''}`}
		>
			<div className={styles.sidebar__wrapper}>
				<div
						className={`${styles.sidebar__nav} ${!showChatNav ? styles['sidebar__nav--full'] : ''}`}
					>
					<Menu
						mode="inline"
						selectedKeys={[selectedSidebar]}
						defaultSelectedKeys={[selectedSidebar]}
						// Closed on load. Expanded it pushed the assistant rail and Get
						// Support below the fold on a laptop, and the submenu is one
						// click away.
						// Controlled: closed on load and re-closed on entering /chat so
						// the assistant rail gets the height (see the openKeys effect).
						// Collapsed to icons, antd runs its own popups, so hand control back.
						openKeys={collapsed ? undefined : openKeys}
						onOpenChange={(keys) => setOpenKeys(keys as string[])}
						inlineCollapsed={collapsed}
						items={items}
						onClick={handleSidebar}
						className="menu-item "
						style={{
							background: '#344735',
							padding: 0,
						}}
					/>
					{showChatNav && <ChatNav collapsed={collapsed} />}
				</div>
				{isGetSupportButton && (
					<div className={styles.sidebar__support}>
						<Button
							type="primary"
							ghost={true}
							className={`${styles['sidebar__support--button']} ${collapsed ? styles['sidebar__support--button-collapsed'] : ''}`}
							onClick={() => {
								window.open('https://costallocationpro.outseta.com/support/kb/categories', '_blank');
								// setSupportModalOpen(true);
							}}
							title="Get Support"
						>
							{collapsed ? (
								<CustomerServiceOutlined
									style={{ fontSize: 20, color: '#fff' }}
								/>
							) : (
								'Get Support'
							)}
						</Button>
					</div>
				)}
			</div>
			{supportModalOpen && (
				<GetSupportModal
					isModalOpen={supportModalOpen}
					handleCancel={handleCancel}
					handleOk={handleSubmit}
				/>
			)}
		</Sider>
	);
};

export default Sidebar;
